import Vue from 'vue'

const state = {
    error: {
        status: false,
        code: 0,
        redirect: false
    }
}

const getters = {
    error: state => {
        return state.error
    }
}

const mutations = {
    setError (state, data) {
        Vue.set(state, 'error', {
            status  : data.status,
            code    : data.code,
            redirect: data.redirect
        })
    }
}

const actions = {}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/error.js